import backgroundVideo from "../../assets/images/weekly star image/weeklyStarContainer.png";

const AutoPlayVideoWithSound = () => {
  return (
    <div className="relative w-full h-[608px] md:h-[300px] overflow-hidden bg-black z-0">
      <img
        src={backgroundVideo}
        className="w-full h-full object-cover"
        // Ensure browsers don't pause it when moving away if possible
      />
    </div>
  );
};

export default AutoPlayVideoWithSound;
